import { SectionShell } from "@/components/design-system/SectionShell";
import { Logo, LogoMark } from "@/components/ui/logo";

const code = `import { Logo, LogoMark } from "@/components/ui/logo";

// Nav rail, drawer headers — mark plus one-line wordmark
<Logo />

// Sign-in and other unauthenticated screens
<Logo layout="stacked" />

// Collapsed rail, or anywhere the wordmark would be redundant.
// Pass \`title\` only when nothing adjacent names the app.
<LogoMark size={22} />
<LogoMark size={22} title="FloorCore Measure" />`;

const SIZES = [44, 32, 24, 22, 16];

export function LogoSection() {
  return (
    <SectionShell
      id="logo"
      title="Logo"
      description={
        <>
          A plan boundary with a measured corner, drawn from the takeoff canvas
          itself. The frame and dimension ticks carry <code>--color-accent</code>
          ; the corner strokes <code>currentColor</code>, so it inherits the
          surrounding ink. There is no separate reversed asset — flip the theme
          toggle above and the corner picks up the design's white-on-navy
          treatment on its own.
        </>
      }
      whenToUse={
        <ul>
          <li>The nav rail and mobile drawer header — <code>&lt;Logo /&gt;</code></li>
          <li>Sign-in, password reset, invite acceptance — <code>layout="stacked"</code></li>
          <li>Collapsed rail or tight chrome — <code>&lt;LogoMark /&gt;</code> alone</li>
        </ul>
      }
      whenNotToUse={
        <ul>
          <li>
            As a decorative icon — reach for <code>lucide-react</code> instead.
          </li>
          <li>
            Recoloured. The green is the token; don't restyle the wordmark's
            "Core" or the eyebrow.
          </li>
          <li>
            Below 16px, or as the browser tab icon — those are generated by{" "}
            <code>script/generate_icons.mjs</code>, not this component.
          </li>
        </ul>
      }
      preview={
        <div className="flex flex-col gap-8">
          <div className="flex flex-wrap items-center gap-x-12 gap-y-8">
            <div className="flex flex-col gap-3">
              <span className="text-xs uppercase tracking-wider text-ink-muted">
                Stacked
              </span>
              <Logo layout="stacked" />
            </div>
            <div className="flex flex-col gap-3">
              <span className="text-xs uppercase tracking-wider text-ink-muted">
                Inline
              </span>
              <Logo />
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <span className="text-xs uppercase tracking-wider text-ink-muted">
              Mark — the ticks drop below 32px and the strokes thicken, so the
              corner still reads
            </span>
            <div className="flex items-end gap-6 text-ink-display">
              {SIZES.map((size) => (
                <div key={size} className="flex flex-col items-center gap-2">
                  <LogoMark size={size} />
                  <span className="font-mono text-[11px] text-ink-muted">
                    {size}
                  </span>
                </div>
              ))}
            </div>
          </div>

        </div>
      }
      code={code}
    />
  );
}
